module.exports = __webpack_public_path__ + "img/Kid2.e655daf5.png";